import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTranslator = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.75 2.41667H4.08333M4.08333 2.41667H7.41667C7.41667 4.88427 6.076 7.03875 4.08333 8.19145M4.08333 2.41667L4.08333 0.75M4.08333 8.19145C3.10276 8.75868 1.96429 9.08333 0.75 9.08333M4.08333 8.19145C3.07124 7.60599 2.22735 6.76209 1.64188 5.75M4.08333 8.19145C5.06391 8.75869 6.20238 9.08333 7.41667 9.08333M15.75 15.75V15.6975C15.75 14.8698 15.6624 14.0497 15.4918 13.25M9.08333 15.75V15.6975C9.08333 14.8698 9.17089 14.0497 9.34154 13.25M9.34154 13.25C9.71992 11.4768 10.5068 9.80396 11.6535 8.37068C12.0447 7.88159 12.7886 7.88159 13.1799 8.37068C14.3265 9.80396 15.1134 11.4768 15.4918 13.25M9.34154 13.25H15.4918",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgTranslator);
export default ForwardRef;
